module.exports = __webpack_public_path__ + "static/media/liveroom-setting-slider-gif.554b139d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroomSetting/liveroom-setting-slider-gif.gif
// module id = 573
// module chunks = 6